import { render } from "./CatalougeItemManager.vue?vue&type=template&id=59fe966a&scoped=true"
import script from "./CatalougeItemManager.vue?vue&type=script&lang=js"
export * from "./CatalougeItemManager.vue?vue&type=script&lang=js"

import "./CatalougeItemManager.vue?vue&type=style&index=0&id=59fe966a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fe966a"]])

export default __exports__